import type {ReactElement} from 'react';
import type {MediaItemData} from '@Components/simple-media-carousel/simple-media-carousel.types';
import styles from './simple-media-carousel-item.module.scss';
import type {DesignSelection} from '@Components/social-media/social-media.types';

export interface SimpleMediaCarouselItemProps {
  mediaItem: MediaItemData;
  index: number;
  onItemMounted: (el: HTMLVideoElement | HTMLImageElement, index: number) => void;
  onItemLoaded: () => void;
  onIndividualVideoLoad?: (externalVideoDesign: DesignSelection) => void;
  onIndividualImageLoad?: (externalImageDesign: DesignSelection) => void;
  onIndividualAssetErrored?: (externalDesing: DesignSelection) => void;
  doRetryOnIndividualAssetError?: () => void;
}

export function SimpleMediaCarouselItem({...props}: SimpleMediaCarouselItemProps): ReactElement<any> {
  const media = props.mediaItem;

  if (media.isVideo) {
    return (
      <div className={styles.mediaContainer} key={`carousel-media-item-${props.index}`}>
        <video
          className={styles.media}
          src={media.mediaUrl}
          ref={(el) => {
            if (el) {
              props.onItemMounted(el, props.index);
            }
          }}
          onLoadedMetadata={() => {
            props.onItemLoaded();
            props.onIndividualVideoLoad?.(media.externalMediaDesign);
          }}
          onError={() => {
            props.onIndividualAssetErrored?.(media.externalMediaDesign);
            props.doRetryOnIndividualAssetError?.();
          }}
          loop
          autoPlay={props.index === 0}
          muted
        />
      </div>
    );
  }

  return (
    <div className={styles.mediaContainer} key={`carousel-media-item-${props.index}`}>
      <img
        className={styles.media}
        src={media.mediaUrl}
        ref={(el) => {
          if (el) {
            props.onItemMounted(el, props.index);
          }
        }}
        alt="media item"
        onLoad={() => {
          props.onItemLoaded();
          props.onIndividualImageLoad?.(media.externalMediaDesign);
        }}
        onError={() => {
          props.onIndividualAssetErrored?.(media.externalMediaDesign);
          props.doRetryOnIndividualAssetError?.();
        }}
      />
    </div>
  );
}
